module.exports = __webpack_public_path__ + "img/unit1-mechanical.ff886a88.svg";